import { useCallback, useEffect, useState } from "react";

export const COLOR_MODE_KEY = "crm-color-mode";
const DEFAULT_MODE = "light";

const VALID_MODES = ["light", "dark"];

export const resolveTheme = (mode) =>
  VALID_MODES.includes(mode) ? mode : DEFAULT_MODE;

export const getStoredMode = () => {
  try {
    const stored = localStorage.getItem(COLOR_MODE_KEY);
    return VALID_MODES.includes(stored) ? stored : DEFAULT_MODE;
  } catch {
    return DEFAULT_MODE;
  }
};

export const applyColorMode = (mode) => {
  document.documentElement.setAttribute(
    "data-coreui-theme",
    resolveTheme(mode)
  );
};

/**
 * Lightweight color-mode controller. Persists the user's preference
 * ("light" | "dark") and reflects it on <html data-coreui-theme>,
 * which drives CoreUI's dark theme + our cinematic overrides project-wide.
 */
export const useColorMode = () => {
  const [colorMode, setColorModeState] = useState(getStoredMode);

  const setColorMode = useCallback((mode) => {
    try {
      localStorage.setItem(COLOR_MODE_KEY, mode);
    } catch {
      /* ignore storage errors */
    }
    setColorModeState(mode);
    applyColorMode(mode);
  }, []);

  useEffect(() => {
    applyColorMode(colorMode);
  }, [colorMode]);

  return { colorMode, setColorMode };
};

export default useColorMode;
